import { FindTriggerAbility } from '@/axios/IDevice.js'
import { clearIFtttListByTriggerCache } from './iftttListByTrigger'

/** @type {Map<string, Promise>} vDeviceId → 进行中的请求或已缓存的结果 */
const cache = new Map()

/**
 * 获取设备 Trigger 能力（同 vDeviceId 复用 Promise，避免多组件重复请求）
 * @param {string|number} vDeviceId
 * @returns {Promise<object>}
 */
export function fetchTriggerAbility(vDeviceId) {
  const id = String(vDeviceId || '').trim()
  if (!id) {
    return Promise.reject(new Error('vDeviceId is required'))
  }

  if (cache.has(id)) {
    return cache.get(id)
  }

  const promise = FindTriggerAbility({ vDeviceId: id }).catch(err => {
    cache.delete(id)
    throw err
  })

  cache.set(id, promise)
  return promise
}

/** 读取 TriggerList */
export function getTriggerList(res) {
  return res?.Result?.TriggerList || []
}

/** 配置变更后清缓存，下次 fetch 会重新请求 */
export function clearTriggerAbilityCache(vDeviceId) {
  if (vDeviceId == null || vDeviceId === '') {
    cache.clear()
    return
  }
  cache.delete(String(vDeviceId))
}

export { clearIFtttListByTriggerCache } from './iftttListByTrigger'

/** 清 Trigger 能力 + IFTTT 列表缓存（绑定/删除后调用） */
export function clearDeviceTriggerDetailCache(vDeviceId) {
  clearTriggerAbilityCache(vDeviceId)
  clearIFtttListByTriggerCache(vDeviceId)
}
